const currentPatVersionList = [177,2]
const currentFullVersionList = [175,3]

export const wiwVersionTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		const indexOfWWStackTrace = desyncdata.lastIndexOf('WickedWhims')

		if (indexOfWWStackTrace !== -1) {
			// Find version - X.X.X.XXX or X.X.X.XXXX or X.X.X.XXX.X or X.X.X.XXX.XX
			const versionStr = desyncdata.slice(indexOfWWStackTrace + 13, indexOfWWStackTrace + 18).replace('/', '').replace('\\', '').trim()

			if (versionStr.length >= 4) {
				let isOutdated = false
				const versionNumberStr = versionStr.split('.')[0]

				// Is full release or not
				if (versionNumberStr.match(/[a-z]/i)) {
					const versionNumberInt = parseInt(versionNumberStr.slice(0, 3), 10)
					const minorVersionInt = "abcdefghijklmnopqrstuvwxyz".indexOf(versionNumberStr[3]) + 1

					if (versionNumberInt < currentFullVersionList[0] || (versionNumberInt === currentFullVersionList[0] && minorVersionInt < currentFullVersionList[1])) {
						isOutdated = true
					}
				} else {
					const versionNumberInt = parseInt(versionNumberStr.slice(0, 3), 10)
					const minorVersionInt = parseInt(versionStr.split('.')[1], 10)

					if (versionNumberInt < currentPatVersionList[0] || (versionNumberInt === currentPatVersionList[0] && minorVersionInt < currentPatVersionList[1])) {
						isOutdated = true
					}
				}

				if (isOutdated === true) {
					return {
						type: 'wiwVersionTest',
                        nonError: true,
						color: 'SlateBlue',
						title: 'Outdated WickedWhims mod',
						text: 'You\'re using an outdated version of WickedWhims.',
						description: 'Visit the <a href="https://wickedwhimsmod.com/" target="_blank" rel="noopener noreferrer">WickedWhims</a> website and update!'
					}
				}
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>385f91033a6da85f5fb44045</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2020-11-17 16:36:44</createtime>
        <buildsignature>Local.Unknown.Unknown.1.68.154.1020-1.200.000.475.Release</buildsignature>
        <categoryid>data_handler.py:631</categoryid>
        <desyncid>385f91033a6da85f5fb44045</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>Exception raised while handling clip events: (AttributeError: 'NoneType' object has no attribute 'whoring_outfit_category_index')
Traceback (most recent call last):
  File &quot;.\WickedWhims_v161c\turbolib2\events\pre_outfit_tracker.py&quot;, line 34, in _turbolib_on_set_current_outfit_without_distribution
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\sim_info_base_wrapper.py&quot;, line 564, in _set_current_outfit_without_distribution
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\callback_utils.py&quot;, line 158, in __call__
  File &quot;E:\\Python3_7_0\\version_vault\\LL\LL_2_7f\NisaK\wickedpervs\prostitution_outfit.py&quot;, line 194, in nisa_hoe_outfit_handler
  File &quot;E:\\Python3_7_0\\version_vault\\LL\LL_2_7f\NisaK\wickedpervs\prostitution_outfit.py&quot;, line 355, in outfit_category_and_index
  File &quot;E:\\Python3_7_0\\version_vault\\LL\LL_2_7f\NisaK\wickedpervs\prostitution_outfit.py&quot;, line 330, in _get_whoring_outfit_category
  File &quot;E:\\Python3_7_0\\version_vault\\LL\LL_2_7f\NisaK\wickedpervs\prostitution_outfit.py&quot;, line 276, in _get_whoring_outfit_category_index
  File &quot;E:\\Python3_7_0\\version_vault\\LL\LL_2_7f\NisaK\utilities\data_handler.py&quot;, line 631, in get_default_whoring_category_index
AttributeError: 'NoneType' object has no attribute 'whoring_outfit_category_index'rtim=0
ClientInfo isn't here</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/mods/wiwVersionTest.js